import React from 'react';
import './main.less';

import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Table from '../../shared/new-table/main';

import wrapMain from '../wrap-main';

function withList(selectors, actions, table, creation) {
	function List({ intl, rows, pagination }) {
		return (
			<div>
				<div className='banners-navigation'>
					<Link
						className='ui-btn ui-btn-primary'
						to={creation.link}
					>
						{intl(creation.text)}
					</Link>
				</div>
				<Table
					className='banners-table'
					table={table}
					rows={rows}
				/>
				{(rows.length < pagination.total) && (
					<div className='banners-button-wrapper'>
						<button
							className='ui-btn ui-btn-secondary banners-button'
							onClick={pagination.showMore}
						>
							{intl('Show more')}
						</button>
					</div>
				)}
			</div>
		);
	}

	function mapStateToProps(state) {
		return {
			rows: selectors.select(state, 'data'),
			isLoading: selectors.select(state, 'isLoading'),
			isError: selectors.select(state, 'isError'),
			// -----------------------------------------
			pagination: selectors.getPagination(state)
		};
	}

	function mapDispatchToProps(dispatch) {
		return {
			...bindActionCreators(actions.own, dispatch),
			pagination: bindActionCreators(actions.pagination, dispatch)
		};
	}

	function mergeProps(stateProps, dispatchProps, ownProps) {
		return {
			...ownProps,
			...stateProps,
			...dispatchProps,
			pagination: {
				...stateProps.pagination,
				...dispatchProps.pagination
			}
		};
	}

	return connect(mapStateToProps, mapDispatchToProps, mergeProps)(wrapMain(List));
}

export default withList;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/with-list/main.js